import { render } from "./App.vue?vue&type=template&id=63890b34"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=63890b34&lang=css"

import exportComponent from "F:\\java\\kmwater\\extserviceh5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__